import React, { useState } from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { Box, Button } from "@material-ui/core";

import CoinManagmentContainer from "@jumbo/Dashboards/CoinMangement/CoinManagementContainer";
import AddCoinDialog from "@jumbo/Dashboards/CoinMangement/AddCoinDialog";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.coinManagement"} />, isActive: true },
];

const JoftPoochCoinManagement = () => {
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  return (
    <PageContainer
      heading={<IntlMessages id="pages.coinManagement" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box
            marginBottom={"10px"}
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <IntlMessages id="pages.coinManagement.description" />
            <Button
              variant="contained"
              color="primary"
              onClick={()=>setAddDialogOpen(true)}
            >
              اضافه کردن کلید
            </Button>
          </Box>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <CoinManagmentContainer />
          </div>
        </Grid>
      </GridContainer>
      <AddCoinDialog
        open={addDialogOpen}
        handleClose={() => setAddDialogOpen(false)}
      />
    </PageContainer>
  );
};

export default JoftPoochCoinManagement;